/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useDispatch} from 'react-redux';
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";
import {useEffect} from "react";

export default function iOS() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setRuleConfig(
			{
				id: 'iOS',
				config: {
					ruleType: "os",
					args: {
						os: ["ios"],
					},
				}
			}
		));
	}, []);

	return <>
		<p>
			This
			rule
			targets
			iOS
			operating
			systems.
		</p>
	</>;
}
